var render = function render(){var _vm=this,_c=_vm._self._c;return _c('report-usages-list',{attrs:{"show-no-energy":"","tokenUid":_vm.token?.uid}})
}
var staticRenderFns = []

export { render, staticRenderFns }